import noop from 'lodash/noop';
import Vue from 'vue';
import type { Location, RawLocation, RouteConfig } from 'vue-router';
import Router from 'vue-router';
import routes from './routes';
Vue.use(Router);

export const isLocation = (to: RawLocation): to is Location => {
  return typeof to !== 'string';
};

const router = new Router({
  routes: routes as RouteConfig[],
  mode: 'history',
});

console.log('Initialized Vue 2 router');

export const addQueryParamsWithoutReload = async (params: Record<string, string>, _router: Router) => {
  return _router.replace({ path: router.currentRoute.path, query: { ...router.currentRoute.query, ...params }, replace: true }).catch(noop);
};

export function getGlobalRouter(): Router {
  return router;
}
